import { ref, push, set, update, remove, onValue } from 'firebase/database'
import { db, tref } from './firebase.js'
import { logActivity } from './activity.js'

// Documents — reference links (waivers, receipts, policies). /club/documents.
//   {id}: { title, category, fileRef, notes, createdAt }
const BASE = 'club/documents'
export const DOC_CATEGORIES = ['Policy', 'Waiver', 'Receipt', 'Vendor', 'Contract', 'Other']

export function watchDocuments(cb) { return onValue(tref(BASE), (s) => cb(s.val() || {})) }
export async function createDocument(d) {
  const title = String(d.title || '').trim(); if (!title) throw new Error('Title is required.')
  const node = push(tref(BASE))
  await set(node, { id: node.key, title, category: d.category || 'Other', fileRef: String(d.fileRef || '').trim(), notes: String(d.notes || '').trim(), createdAt: Date.now() })
  logActivity({ type: 'document', icon: '📄', text: `Document added: ${title}` })
  return node.key
}
export async function updateDocument(id, patch) {
  const clean = {}
  for (const k of ['title', 'fileRef', 'notes']) if (patch[k] != null) clean[k] = String(patch[k]).trim()
  if (patch.category != null) clean.category = patch.category
  await update(tref(`${BASE}/${id}`), clean)
}
export async function deleteDocument(id) { await remove(tref(`${BASE}/${id}`)) }
